export default __webpack_public_path__ + "static/media/arrow-circle-left-outline.dc43a3fb.svg";